import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, useTheme } from '@mui/material';
import { Scale } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const login = useAuthStore(state => state.login);
  const theme = useTheme();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await login(email, password);
    if (success) navigate('/cases');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        background: theme.palette.mode === 'light'
          ? 'linear-gradient(135deg, rgba(30, 58, 95, 0.03), rgba(45, 78, 125, 0.05))'
          : 'linear-gradient(135deg, rgba(19, 40, 68, 0.2), rgba(30, 58, 95, 0.3))',
        px: { xs: 2, sm: 4 },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: { xs: 4, sm: 6 },
          width: '100%',
          maxWidth: 440,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box 
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: 64, sm: 72 },
            height: { xs: 64, sm: 72 },
            borderRadius: '20px',
            background: theme.palette.mode === 'light'
              ? 'linear-gradient(135deg, #1e3a5f, #2d4e7d)'
              : 'linear-gradient(135deg, #132844, #1e3a5f)',
            mb: 3,
          }}
        >
          <Scale 
            size={36}
            color="#fff"
            style={{
              filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
            }}
          />
        </Box>
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 4,
            fontWeight: 700,
            fontSize: { xs: '1.75rem', sm: '2rem' },
            letterSpacing: '-0.02em',
            color: 'text.primary',
            textAlign: 'center',
          }}
        >
          LegalCo
        </Typography>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            size="large"
            type="submit"
            sx={{ 
              mt: 4,
              mb: 2,
              py: 1.5,
              fontSize: '1rem',
            }}
          >
            Sign In
          </Button>
        </form>
      </Paper>
    </Box>
  );
};